<template>
  <div class="pagenation">
    <router-link
      :to="{ query: { page: current - 1 }}" 
      v-if="current !== 1"
      class="page-btn-back"
    >&lt; 前へ</router-link>
    <span class="page-number">
      <span class="page-number--current">{{current}}</span>
      /{{pageLast}}
    </span>
    <router-link
      :to="{ query: { page: (current + 1) }}"
      v-if="current !== pageLast"
      class="page-btn-next"
    >次へ &gt;</router-link>
  </div>
</template>

<script>
// v-on:click.native="setPv()"
export default {
  data: function() {
    const current = this.$route.query.page
      ? Number(this.$route.query.page)
      : 1
    
    return {
      current: current
    }
  },
  props: {
    count: {
      type: Number,
      required: true,
      default: 0
    },
    perPage: {
      type: Number,
      default: 30
    }
  },
  computed: {
    pageLast() {
      const page = Math.ceil(this.count / this.perPage);
      return page > 0 ?  page : 1
    }
  },
  watch: {
    $route: 'setCurrent'
  },
  methods: {
    setCurrent() {
      this.current = this.$route.query.page
        ? Number(this.$route.query.page)
        : 1
    }
  }
}
</script>

<style lang="scss">
.pagenation {
  padding: 10px 0;

  .page-number {
    display: inline-block;
    margin: 0 10px;
    font-size: 1.2em;

    .page-number--current {
      font-size: 140%;
      font-weight: bold;
    }
  }
}
</style>